import List from './list/NotViewableEventTypeListInitialState'

const { Record } = require('immutable')

const InitialState = Record({
    list: List()
})

export default InitialState